module.exports = __webpack_public_path__ + "img/offeo-10.be54b3e3.png";